var ee = (l) => {
  throw TypeError(l);
};
var j = (l, i, e) => i.has(l) || ee("Cannot " + e);
var k = (l, i, e) => (j(l, i, "read from private field"), e ? e.call(l) : i.get(l)), A = (l, i, e) => i.has(l) ? ee("Cannot add the same private member more than once") : i instanceof WeakSet ? i.add(l) : i.set(l, e), M = (l, i, e, a) => (j(l, i, "write to private field"), a ? a.call(l, e) : i.set(l, e), e), R = (l, i, e) => (j(l, i, "access private method"), e);
import { i as X } from "../separate-component-helper-chunks/reactive-element-CzWTglSF.js";
import { render as be, html as E } from "../beacon-html.d/index.js";
import "../separate-component-helper-chunks/lit-element-sPTOReu4.js";
import { property as B } from "../beacon-property.d/index.js";
import { state as K } from "../beacon-state.d/index.js";
import { query as ne } from "../beacon-query.d/index.js";
import { map as G } from "../beacon-map.d/index.js";
import { B as he, e as ae } from "../separate-component-helper-chunks/abstract-base-DDNz9tUt.js";
import { B as F } from "../separate-component-helper-chunks/events-CMiHMbSn.js";
import { B as I, L as z } from "../separate-component-helper-chunks/table-stub-Bcv1Qq74.js";
import { B as W, S as q, f as me } from "../separate-component-helper-chunks/table-header-BzglV3Iw.js";
import { B as Z, T as te } from "../separate-component-helper-chunks/table-record-CyFwHqoY.js";
import { m as pe } from "../separate-component-helper-chunks/mixin-DsSIi_3b.js";
import { W as fe } from "../separate-component-helper-chunks/watch-media-C9Kp7I0W.js";
import { c as ge } from "../separate-component-helper-chunks/cache-Cmvf5ilk.js";
import { w as V } from "../separate-component-helper-chunks/lifecycle-decorators-Cg3csm0R.js";
import { s as ue } from "../separate-component-helper-chunks/scrollableRegion-Cbxt6UUr.js";
import { g as ve } from "../separate-component-helper-chunks/uid-HAKIZOcY.js";
var $ = /* @__PURE__ */ ((l) => (l.MOVABLE = "movable", l.FIXED = "fixed", l.FLOATING = "floating", l))($ || {});
function oe(l, i, e) {
  l != 0 ? i == null || i.classList.add(e) : i == null || i.classList.remove(e);
}
const ye = "td", Ce = "table";
function we(l) {
  var r;
  if (!l) return;
  const i = l.closest(ye);
  if (!i) return;
  const e = Array.prototype.indexOf.call(
    (r = i == null ? void 0 : i.parentNode) == null ? void 0 : r.children,
    i
  );
  if (!e) return;
  const a = i.closest(Ce);
  if (!a || !a.rows) return;
  let t = 0, o;
  for (o = 0; t <= e; o += 1) {
    const n = a.rows[0].cells[o];
    if (!n) break;
    n.dataset.colSpan ? t += parseInt(n.dataset.colSpan, 10) : t += n.colSpan;
  }
  return a.rows[0].cells[o - 1];
}
const Se = X`:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-3);--table-caption-summary-spacer: var(--beacon-reference-space-5);--table-caption-spacer-jumbo: var(--beacon-reference-space-5);--table-caption-spacer-normal: var(--beacon-reference-space-3);--table-row-space-padding: var(--beacon-reference-space-2)}@media (width >= 640px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-4);--table-row-space-padding: var(--beacon-reference-space-3)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-caption-summary-spacer: var(--beacon-reference-space-7);--table-caption-spacer-jumbo: var(--beacon-reference-space-7);--table-caption-spacer-normal: var(--beacon-reference-space-5);--table-row-space-padding: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-2)}}`, re = {
  beaconTagName: "beacon-table"
}, ke = {
  Standard: "standard"
}, Te = X`[beacon-tag-name=beacon-table]{--layer-base: 1;--layer-headers: calc(var(--layer-base) + 1);--layer-headers-sticky: calc(var(--layer-headers) + 1);--layer-popover: calc(var(--layer-headers-sticky) + 1);--table-thead-position: sticky;background-color:transparent}[beacon-tag-name=beacon-table][static-header]{--table-thead-position: relative;--layer-headers: auto}[beacon-tag-name=beacon-table]:is(.beacon-on-light,.beacon-on-dark){background-color:transparent}[beacon-tag-name=beacon-table] .beacon-table{box-sizing:border-box;border:inherit;color:inherit;letter-spacing:inherit;line-height:inherit;white-space:inherit;word-spacing:inherit;font-family:inherit;font-size:inherit;font-style:inherit;font-variant:inherit;font-weight:inherit;text-align:inherit;text-indent:inherit;text-transform:inherit;background-color:var(--beacon-system-color-background-1);border-collapse:separate;border-spacing:0;min-inline-size:100%;overflow-wrap:break-word;position:relative;table-layout:var(--beacon-table-layout, fixed)}[beacon-tag-name=beacon-table] .beacon-table *,[beacon-tag-name=beacon-table] .beacon-table *:after,[beacon-tag-name=beacon-table] .beacon-table *:before{box-sizing:inherit}[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-radius:var(--beacon-system-radius-corner-standard)}}[beacon-tag-name=beacon-table] .beacon-table.container-has-left-border{border-inline-start:none}[beacon-tag-name=beacon-table] .beacon-table.container-has-right-border{border-inline-end:none}[beacon-tag-name=beacon-table] .beacon-table a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-table] .beacon-table caption{background-color:var(--beacon-system-color-background-1);padding-block-end:var(--beacon-reference-space-5);text-align:start}[beacon-tag-name=beacon-table] .beacon-table thead{inset-block-start:0;position:var(--table-thead-position);z-index:var(--layer-headers)}[beacon-tag-name=beacon-table] .beacon-table :is(th,td){--cell-color: var(--beacon-system-color-text-standard);--cell-text-alignment: initial;--modern-outlook-table-cell-padding: calc(var(--beacon-component-table-space-cell) + var(--beacon-system-space-cell-contained));background-color:var(--beacon-system-color-background-1);color:var(--cell-color);padding-block:var(--modern-outlook-table-cell-padding);padding-inline:var(--modern-outlook-table-cell-padding);position:relative;text-align:var(--cell-text-alignment);vertical-align:top}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot){--divider-border-color: var(--beacon-component-table-color-border)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) :is(th,td){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) th{--cell-text-alignment: start}[beacon-tag-name=beacon-table] .beacon-table tbody th:after{border-block-end:var(--inset-divider-border);content:"";display:block;margin-block:0;margin-inline:var(--inset-divider-margin-start) var(--inset-divider-margin-end);padding-block-start:var(--inset-divider-padding-block-start)}[beacon-tag-name=beacon-table] .beacon-table thead th{--cell-background: var(--beacon-system-color-background-2);--cell-color: var(--beacon-system-color-text-standard);--divider-border-color: var(--beacon-component-table-color-border);background-color:var(--cell-background);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan]{padding-block-end:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table] .beacon-table thead th:not([colspan]),[beacon-tag-name=beacon-table] .beacon-table thead th[colspan][has-dropdown]{border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:not(:first-of-type) th,[beacon-tag-name=beacon-table] .beacon-table thead tr:first-of-type th:not(:last-of-type){border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:first-child{border-start-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:last-child{border-start-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child th:first-child{border-end-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child td:last-child{border-end-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:not(:last-of-type)>:is(th,td){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tfoot tr>:is(th,td){border-block-start-color:var(--divider-border-color);border-block-start-style:var(--border-style);border-block-start-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tr:is([data-beacon-selected],[data-beacon-highlighted]) th:first-of-type:before{background-color:var(--beacon-system-color-border-brand);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-jumbo);inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-highlighted] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-selected] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-highlighted] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-selected] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-header thead{z-index:var(--layer-headers-sticky)}[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end th,[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end td{border-block-end-color:transparent!important}[beacon-tag-name=beacon-table][multi-level] .beacon-table :is(tbody,tfoot) th{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{inset-inline-start:0;position:sticky}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th{z-index:var(--layer-base)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th:has([is-open]){z-index:var(--layer-popover)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{z-index:var(--layer-headers)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column{--sticky-cell-elevation: auto;--sticky-cell-elevation-stub: auto}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type{filter:drop-shadow(var(--sticky-cell-elevation, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end:0;filter:drop-shadow(var(--sticky-cell-elevation-stub, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub{--table-stub-floating-override-margin-inline-start: 0%}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub :is(tbody,tfoot) th{padding:0}[beacon-tag-name=beacon-table] [data-beacon-sort-state=false] [data-beacon-sort]{display:none}[beacon-tag-name=beacon-table] [data-beacon-sort]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-5);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-table] [data-beacon-sort] svg{fill:var(--beacon-system-color-icon-tertiary)}[beacon-tag-name=beacon-table] [aria-sort=ascending] [data-beacon-sort] svg:not(.ascending){display:none}[beacon-tag-name=beacon-table] [aria-sort=descending] [data-beacon-sort] svg:not(.descending){display:none}[beacon-tag-name=beacon-table] [aria-sort]:not([aria-sort=none]){background-color:var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-table] th:is(:not([aria-sort]),[aria-sort=none]) [data-beacon-sort] svg:not(.default){display:none}[beacon-tag-name=beacon-table][sortable] .beacon-table :is(td,th)[data-beacon-sorted=true]{font-weight:var(--beacon-system-font-weight-bold)}`, Le = X`:host{--border-style: solid;word-break:initial}.table-container{block-size:var(--beacon-custom-table-container-block-size, auto);display:var(--table-container-display, block);inline-size:var(--beacon-custom-table-container-inline-size, auto);margin-inline:var(--inline-margin, 0);overflow-x:var(--beacon-custom-table-container-overflow-x, initial);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track)}.table-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}.table-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}.table-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container.full-bleed{--inline-margin: calc(50% - 50vw) }.table-container.add-full-border{border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){.table-container.add-full-border{border-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-bottom-border{border-block-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-bottom-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-left-border{border-inline-start:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-left-border{border-end-start-radius:var(--beacon-system-radius-corner-standard);border-start-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-right-border{border-inline-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-right-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-start-end-radius:var(--beacon-system-radius-corner-standard)}}.transformed-cards{--beacon-body-font-size-100: var(--beacon-reference-space-4);--table-override-header-sort-icon-display: none;--table-override-header-wrapper-inline-size: fit-content;--table-override-stub-action-zone-right-space: 0;--table-override-stub-content-space-margin-inline-start: 0;--table-override-stub-dropdown-display: none;--table-override-header-dropdown-display: none;display:var(--transformed-cards-display, none)}.transformed-cards [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: 0;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.transformed-cards [beacon-tag-name=beacon-table-header]::part(text-cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell-wrapper){margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(action-zone){margin-inline-start:var(--beacon-reference-space-3)}.transformed-cards [beacon-tag-name=beacon-table-stub]{--stub-content-margin-inline-end: 0;--stub-content-margin-inline-start: 0}.transformed-cards [beacon-tag-name=beacon-table-stub]::part(content){padding:0}.transformed-cards [beacon-tag-name=beacon-table-header],.transformed-cards [beacon-tag-name=beacon-table-record],.transformed-cards .stub,.transformed-cards .header,.transformed-cards .record{color:var(--beacon-system-color-text-standard);font-size:var(--beacon-reference-space-4)}.transformed-cards .card{background-color:var(--beacon-system-color-background-primary);border-radius:var(--beacon-system-radius-corner-circle);display:grid;gap:var(--beacon-reference-space-5);padding:var(--beacon-reference-space-5)}.transformed-cards .card:not(:last-of-type){margin-block-end:var(--beacon-reference-space-5)}.transformed-cards .card .stub{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.transformed-cards .card-data{display:grid;font-size:var(--beacon-reference-space-3);gap:var(--beacon-reference-space-5)}.transformed-cards .card-row{padding-block-end:var(--padding-block-end)}.transformed-cards .card-row .header{flex:1;line-height:1.6}.transformed-cards .card-row .record{font-weight:var(--beacon-system-font-weight-bold);line-height:1.43}.transformed-cards .card-row:not(.grouped){align-items:center}.transformed-cards .card-row.grouped{--padding-block-end: var(--beacon-reference-space-5);display:flex;flex-direction:column}.transformed-cards .card-row:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-secondary)}.transformed-cards .card-row.single{--padding-block-end: var(--beacon-reference-space-5)}.transformed-cards .grid{display:grid;grid-template-columns:1fr 1fr}.transformed-cards .grid .record,.transformed-cards .grid [beacon-tag-name=beacon-table-record]{justify-self:end}.transformed-cards .header-children :is(.header,[beacon-tag-name=beacon-table-header]){text-indent:var(--beacon-reference-space-5)}:host([is-scrolling-block]) .table-container{block-size:calc(var(--js-component-size-block) - var(--table-space-padding) * 4)}:host([use-cards]){--table-container-display: none;--transformed-cards-display: block}:host([use-cards]) a{color:var(--beacon-system-color-text-link)}@media (width >= 640px){.table-container.full-bleed{--inline-margin: 0}:host([use-cards]){--table-container-display: block;--transformed-cards-display: none}}`;
var xe = Object.defineProperty, Re = Object.getOwnPropertyDescriptor, v = (l, i, e, a) => {
  for (var t = a > 1 ? void 0 : a ? Re(i, e) : i, o = l.length - 1, r; o >= 0; o--)
    (r = l[o]) && (t = (a ? r(i, e, t) : r(t)) || t);
  return a && t && xe(i, e, t), t;
}, L, O, H, x, d, se, ce, N, _, U, ie;
const u = (d = class extends pe(he).with(fe) {
  constructor() {
    super(...arguments);
    A(this, N);
    A(this, L);
    A(this, O);
    A(this, H);
    this.beaconTagName = re.beaconTagName, this.deferOptions = { rootMargin: "3000px" }, M(this, L, {
      stickyStub: "has-sticky-stub-column",
      stickyHeader: "has-sticky-header",
      lightDOMTable: "beacon-table",
      floatingStub: "floating-stub"
    }), this.variant = $.MOVABLE, this.sortable = !1, this.useCards = !1, this.hasMultiLevel = !1, this.mobileFullBleed = !1, this.density = ke.Standard, this.staticHeader = !1, this.scrollPositionBlock = 0, this.scrollPositionInline = 0, M(this, H, !1), this.sortRows = (e) => {
      var n, b, f;
      const { target: a } = e;
      if (!a) return;
      this.mutationObserver.disconnect(), this.querySelectorAll("[aria-sort]").forEach((s) => {
        var c;
        a !== s && R(c = d, x, U).call(c, s, "none");
      });
      let o;
      if (a instanceof W) {
        const s = a.parentElement, c = (n = this.table) == null ? void 0 : n.querySelector("tbody"), h = s instanceof HTMLTableCellElement;
        if (!s || !c || !h)
          return;
        const m = d.getOrderedHeaders(this.headers);
        if (a.dropdown && a.selectedValue) {
          const y = a.selectedValue;
          o = m.map((w) => w.id).indexOf(y);
        } else
          o = m.indexOf(
            s
          );
        const p = d.sortRowData(
          this,
          c,
          a,
          o
        );
        d.renderSortedRows(c, p);
        const C = e.target instanceof W ? (b = e == null ? void 0 : e.detail) == null ? void 0 : b.id : null;
        this.updateSortAttributes(C);
      } else {
        const s = a, c = (f = this.table) == null ? void 0 : f.tBodies[0];
        o = d.getOrderedHeaders(this.headers).indexOf(
          s
        );
        const m = d.sortRowData(
          this,
          c,
          s,
          o
        );
        d.renderSortedRows(c, m);
      }
    }, this.mutationObserver = new MutationObserver(
      (e) => {
        if (this.useCards) {
          const a = ["table", "thead", "tbody", "tr"];
          e.forEach((t) => {
            const { target: o, type: r } = t;
            r === "childList" && (o.assignedSlot || a.includes(o.nodeName.toLowerCase())) && this.renderTransformedCards();
          });
        }
      }
    ), this.compare = (e, a) => k(this, O) === q.ASCENDING ? e.value === a.value ? 0 : typeof e.value == "number" && typeof a.value == "number" ? e.value - a.value : e.value < a.value ? -1 : 1 : k(this, O) === q.DESCENDING ? e.value === a.value ? 0 : typeof e.value == "number" && typeof a.value == "number" ? a.value - e.value : e.value > a.value ? -1 : 1 : 0;
  }
  static get styles() {
    return [super.styles, Le];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Te, Se];
  }
  get headers() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("thead th");
  }
  get stubs() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("tbody tr th:first-of-type");
  }
  get records() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("td");
  }
  get table() {
    return ge(
      this,
      "_table",
      () => this.querySelector("table")
    );
  }
  /**
   * @deprecated since version 4.3.0. Prefer to select the table using CSS.
   * It is a slotted element, so this does not need to be public.
   * @todo Remove this getter entirely in the next major version upgrade.
   */
  get slottedTable() {
    return this.table;
  }
  static getSortValue(e) {
    const { firstElementChild: a } = e;
    return a instanceof Z ? R(this, x, se).call(this, a) : R(this, x, ce).call(this, e);
  }
  /**
   * Iterates through a Nodelist of BeaconTableRecords and sets 'bold' prop to false.
   * Otherwise, updates the data attribute from standard table cells.
   * @param tableRecords list of Elements
   */
  static resetRecordBoldSortStyles(e) {
    e.forEach((a) => {
      a.firstElementChild instanceof Z ? a.firstElementChild.sorted = !1 : a.dataset.beaconSorted = "false";
    });
  }
  /**
   * Sorts the `<tr>` 'rowNodes' of a `<tbody>` element. It retrieves sorting criteria from a BeaconTableHeader and sorts all records in a given column.
   * The function has several sorting exceptions for unsortable elements such as level-2 and level-3 BeaconTableStubs and their respective rows which
   * must remain directly below their parental level-1 BeaconTableStub and its row.
   * @param tableBodyElement a `<tbody>` element
   * @param tableHeaderElement a BeaconTableHeader
   * @param columnIndex index of the column where records are sorted
   * @returns a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   *
   * @todo: Need a concrete API decision for how to distinguish the different levels of stubs so native tables can account for them in sorting
   */
  static sortRowData(e, a, t, o) {
    const r = [], n = [], b = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    let s = 0, c = a == null ? void 0 : a.firstElementChild, h = null, m = null, p = [];
    for (; c; ) {
      const w = c.querySelectorAll("th, td"), g = w[0].firstElementChild;
      d.resetRecordBoldSortStyles(w);
      const T = w[o], D = T.firstElementChild;
      if (D instanceof Z ? D.sorted = !0 : T.dataset.beaconSorted = "true", g instanceof I && g.level === z.ONE || !(g instanceof I)) {
        m && p.length && (f.set(m, [
          ...p
        ]), m = null, p = []), r.push(c);
        const S = d.getSortValue(T), P = {
          index: s,
          value: S
        };
        n.push(P), s += 1;
      }
      g instanceof I && (g.level === z.ONE && (h = g), g.level === z.TWO && h && (m = g, b.set(
        h,
        g
      )), g.level === z.THREE && m && p.push(g)), c = c.nextElementSibling;
    }
    m && p.length && f.set(m, [
      ...p
    ]);
    const C = {
      levelOne: b,
      levelTwo: f
    }, y = t instanceof W ? t.compare : e.compare;
    return n.sort(y), {
      rowNodes: r,
      dataCells: n,
      tableStubMap: C
    };
  }
  /**
   * Rendering function that appends the sorted rowNode `<tr>`s to the `<tbody>`.
   * @param tableBodyElement a `<tbody>` element
   * @param sortData a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   */
  static renderSortedRows(e, a) {
    const { rowNodes: t, dataCells: o, tableStubMap: r } = a;
    !o || !t.length || o.forEach((n) => {
      var b, f;
      if (n) {
        const s = t[n.index], c = (b = s.firstElementChild) == null ? void 0 : b.firstElementChild;
        if (e == null || e.appendChild(s), c instanceof I && c.level === z.ONE) {
          const h = r.levelOne.get(
            c
          ), m = (f = h == null ? void 0 : h.parentElement) == null ? void 0 : f.parentElement;
          if (h && m) {
            e == null || e.appendChild(m);
            const p = r.levelTwo.get(h);
            p && p.length && p.forEach(
              (C) => {
                var w;
                const y = (w = C.parentElement) == null ? void 0 : w.parentElement;
                y && (e == null || e.appendChild(
                  y
                ));
              }
            );
          }
        }
      }
    });
  }
  /**
   * A function that takes a NodeList of header TableCellElements sifts through them in search of nested headers.
   * When it finds nestedHeaders it splices them in the appropriate column order so that each header's index matches
   * its corresponding column of tableRecords.
   * @param headersNodeList a Nodelist of `<th>`'s
   * @returns sorted array of headers.
   */
  static getOrderedHeaders(e) {
    const a = [], t = {};
    e == null || e.forEach((o) => {
      o instanceof HTMLTableCellElement && (o.headers ? t[o.headers] ? t[o.headers].push(o) : t[o.headers] = [o] : a.push(o));
    });
    for (const [o, r] of Object.entries(t)) {
      const n = a.map((b) => b.id).indexOf(o);
      a.splice(n, 1, ...r);
    }
    return a;
  }
  /** Attribute triggers vertical-divider styles for `<th>` elements in `<tbody>` in multi-level stub context. */
  _setMultiLevelAttribute() {
    this.toggleAttribute("multi-level", this.hasMultiLevel);
  }
  // this is called by table stubs
  _setMultiLevel(e) {
    this.hasMultiLevel = e;
  }
  /** Receive scroll events on the component and set scroll position states. */
  captureScrollPosition(e) {
    var r, n, b;
    const { target: a } = e, { scrollLeft: t, scrollTop: o } = a;
    if (this.scrollPositionInline = t, this.scrollPositionBlock = o, this.variant === $.FLOATING) {
      const f = (n = (r = this.table) == null ? void 0 : r.querySelector("thead th")) == null ? void 0 : n.clientWidth, s = Math.abs(this.scrollPositionInline) + "px";
      this.style.setProperty(
        "--table-stub-floating-override-inset-inline-start",
        s
      ), f && f * 0.8 < this.scrollPositionInline ? this.table.classList.add(k(this, L).floatingStub) : (b = this.table) == null || b.classList.remove(k(this, L).floatingStub);
    }
    this.variant === $.FIXED && oe(
      this.scrollPositionInline,
      this.table,
      k(this, L).stickyStub
    ), oe(
      this.scrollPositionBlock,
      this.table,
      k(this, L).stickyHeader
    ), this.updateTableBorders();
  }
  getTableAndContainerRects() {
    var h, m, p;
    const e = (m = (h = this.table) == null ? void 0 : h.getBoundingClientRect()) != null ? m : new DOMRect(), a = this.tableContainer.getBoundingClientRect(), t = e.top - a.top, o = e.left - a.left, r = e.right - a.right, n = e.bottom, f = a.bottom - n, s = (p = this.table) == null ? void 0 : p.querySelector("caption");
    let c = 0;
    return s && (c = s.getBoundingClientRect().top - a.top), {
      tableRect: e,
      containerRect: a,
      tableDistanceFromContainerTop: t,
      tableDistanceFromContainerLeft: o,
      tableDistanceFromContainerRight: r,
      distanceFromContainerBottom: f,
      captionElement: s,
      captionDistanceFromContainerTop: c
    };
  }
  addContainerLeftRightBorders({
    tableDistanceFromContainerLeft: e,
    tableDistanceFromContainerRight: a
  }) {
    var t, o;
    this.tableContainer.classList.toggle(
      "add-left-border",
      e < 0
    ), (t = this.table) == null || t.classList.toggle(
      "container-has-left-border",
      e < 0
    ), this.tableContainer.classList.toggle(
      "add-right-border",
      a >= 0
    ), (o = this.table) == null || o.classList.toggle(
      "container-has-right-border",
      a >= 0
    );
  }
  /**
   * Updates the table borders based on the table and container bounding rectangles
   */
  updateTableBorders() {
    var c, h, m, p, C, y, w, g, T;
    const {
      containerRect: e,
      tableDistanceFromContainerTop: a,
      tableDistanceFromContainerLeft: t,
      tableDistanceFromContainerRight: o,
      captionElement: r,
      captionDistanceFromContainerTop: n
    } = this.getTableAndContainerRects(), b = (h = (c = this.table) == null ? void 0 : c.querySelector("thead")) == null ? void 0 : h.getBoundingClientRect(), f = (p = (m = this.table) == null ? void 0 : m.querySelector("tbody")) == null ? void 0 : p.getBoundingClientRect(), s = b ? b.top - e.top : f ? f.top - e.top : 0;
    r ? (n <= 0 && s === 0 && (this.tableContainer.classList.contains("add-full-border") || this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (C = this.table) != null && C.classList.contains("container-has-border") || (y = this.table) == null || y.classList.add("container-has-border")), n <= 0 && s > 1 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (w = this.table) == null || w.classList.remove("container-has-border"))) : (s <= 0 && a < 0 && (this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (g = this.table) == null || g.classList.add("container-has-border")), a >= 0 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (T = this.table) == null || T.classList.remove("container-has-border"))), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: t,
      tableDistanceFromContainerRight: o
    });
  }
  /** Adds a bottom, left or right border to the table container on initial load if the table overflows. */
  addContainerBorders() {
    const {
      distanceFromContainerBottom: e,
      tableDistanceFromContainerLeft: a,
      tableDistanceFromContainerRight: t
    } = this.getTableAndContainerRects();
    e < 0 && this.tableContainer.classList.add("add-bottom-border"), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: a,
      tableDistanceFromContainerRight: t
    });
  }
  /** Handler to render transformed cards when table is resized to mobile view. */
  _handleBreakpointChanges() {
    !this.isMediumBreakpoint && this.useCards && (this.renderTransformedCards(), this.table && this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    }));
  }
  /**
   * Creates content for the cards from the stub, header, or record parent elements.
   * @param start Element to use as the reference node
   * @param type The type of component the final result is, such as 'stub' or 'header' or 'record'
   * @returns A new element made from the children of the starting element
   */
  static generateCardContent(e, a) {
    const t = document.createElement("div"), o = Array.from(
      e.childNodes,
      (b) => b.cloneNode(!0)
    );
    o && t.append(...o);
    const r = ve(), n = "uuid";
    return e.setAttribute(n, r), t.setAttribute(n, r), t.classList.add(a), t;
  }
  /**
   * Clones a Beacon Table Cell and changes its state.
   * @param component Beacon Table component to be cloned
   * @returns Clone of the node with its state changed
   */
  static cloneComponent(e) {
    const a = e.cloneNode(!0);
    return a.isOriginal = !1, a;
  }
  /** For mobile card view, iterate over all child components and clone them into cards. */
  async renderTransformedCards() {
    await this.updateComplete;
    const e = "stub", a = "header", t = "record", o = G(
      this.stubs,
      (r) => {
        if (!this.records) return;
        const n = Array.from(this.records).filter(
          (s) => {
            var c;
            return (c = r.parentNode) == null ? void 0 : c.contains(s);
          }
        ), b = r.querySelector(
          this.getScopedTagName("beacon-table-stub")
        ), f = b ? d.cloneComponent(b) : d.generateCardContent(r, e);
        return E`
          <div class="card">
            ${f}
            <div class="card-data">
              ${G(
          this.headers,
          (s, c) => {
            if (!this.records || c === 0) return;
            let h = E``, m = "single grid", p;
            const C = Array.from(this.records).filter(
              (S) => we(S) === s
            );
            if (!C) return h;
            const y = C.find(
              (S) => n.includes(S)
            );
            if (!y) return h;
            const g = me(
              s,
              !1,
              !1,
              ["th"]
            ), T = s.querySelector(
              this.getScopedTagName("beacon-table-header")
            ), D = T ? d.cloneComponent(T) : d.generateCardContent(s, a);
            if (g && g.length > 0)
              m = "grouped", h = E`${D}
                    ${G(
                g,
                (S, P) => {
                  const le = n.indexOf(y) + P, J = n[le], Q = S.querySelector(
                    this.getScopedTagName("beacon-table-header")
                  ), de = Q ? d.cloneComponent(Q) : d.generateCardContent(
                    S,
                    a
                  ), Y = J.querySelector(
                    this.getScopedTagName("beacon-table-record")
                  );
                  return p = Y ? d.cloneComponent(Y) : d.generateCardContent(
                    J,
                    t
                  ), E`
                          <div class="header-children grid">
                            ${de} ${p}
                          </div>
                        `;
                }
              )} `;
            else {
              const S = y.querySelector(
                this.getScopedTagName("beacon-table-record")
              );
              p = S ? d.cloneComponent(S) : d.generateCardContent(
                y,
                t
              ), h = E` ${D} ${p} `;
            }
            return E`
                    <div class="card-row ${m}">${h}</div>
                  `;
          }
        )}
            </div>
          </div>
        `;
      }
    );
    be(o, this._transformedCardsContainer), ae(this, F.RENDER_TABLE_CARDS), this.triggerRecordActionZoneStatus();
  }
  /**
   * Manually calls `setActionZoneStatus` on each BeaconTableRecord component in the cards to make sure the slot area is visible or hidden as needed.
   */
  async triggerRecordActionZoneStatus() {
    this._transformedCardsContainer.querySelectorAll(
      this.getScopedTagName("beacon-table-record")
    ).forEach(
      async (a) => {
        await a.updateComplete, a.setActionZoneStatus();
      }
    );
  }
  _handleCardChanges() {
    this.isMobile && this.useCards && this.renderTransformedCards();
  }
  _handleSortChanges() {
    this.sortable ? R(this, N, ie).call(this) : R(this, N, _).call(this);
  }
  /**
   * This updates sort-inactive attributes on all BeaconTableHeaders except the one that triggered the sort event.
   * @param targetId Id of BeaconTableHeader that triggered the sort event
   */
  updateSortAttributes(e) {
    var t;
    const a = this.querySelectorAll(
      this.getScopedTagName("beacon-table-header")
    );
    for (const o of a)
      ((t = o.parentElement) == null ? void 0 : t.id) !== e && o.resetSortedAttr();
  }
  // Not using @prerender here because table needs to be able to sort in defer-until=visible context.
  connectedCallback() {
    setTimeout(
      () => this.addEventListener(
        F.SORT,
        this.sortRows
      ),
      100
    ), super.connectedCallback();
  }
  async firstUpdated() {
    this.table && (this.table.classList.add(k(this, L).lightDOMTable), await this.updateComplete, this.useCards && this.isMobile && (this.renderTransformedCards(), this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    })), this.addContainerBorders()), super.firstUpdated();
  }
  render() {
    return E`
      <div class="transformed-cards"></div>
      <div
        class="table-container ${this.mobileFullBleed ? "full-bleed" : "contained"}"
        tabindex=${ue()}
        @scroll=${this.captureScrollPosition}>
        <slot></slot>
      </div>
    `;
  }
}, L = new WeakMap(), O = new WeakMap(), H = new WeakMap(), x = new WeakSet(), se = function(e) {
  const { variant: a, sortValue: t } = e;
  return t && (a === te.NUMERAL || a === te.DATE) ? parseFloat(t) : t;
}, ce = function(e) {
  var n;
  const {
    innerText: a,
    dataset: { beaconSortValue: t, beaconSortType: o }
  } = e, r = (n = a == null ? void 0 : a.toLowerCase().trim()) != null ? n : "";
  return o === "number" ? parseFloat(t || r) : t != null ? t : r;
}, N = new WeakSet(), /** Updates the sort state for sortable headers that aren't a BeaconTableHeader. */
_ = function() {
  const e = this.querySelectorAll(
    "[data-beacon-sort-state]"
  );
  for (const a of e)
    a.dataset.beaconSortState = String(this.sortable);
}, U = function(e, a) {
  const t = e.querySelector("[data-beacon-sort]"), o = t == null ? void 0 : t.querySelector(".sort-text");
  if (o) {
    switch (a) {
      case "ascending":
      case "descending":
        o.innerHTML = `Sorted ${a}`;
        break;
      case "none":
        o.innerHTML = "Sort";
        break;
    }
    e.setAttribute("aria-sort", a);
  }
}, ie = function() {
  if (R(this, N, _).call(this), k(this, H)) return;
  const e = this.querySelector("thead"), a = e == null ? void 0 : e.querySelectorAll("th"), t = document.createElement("template");
  t.innerHTML = `
      <style>
        .base {
          display: grid;
          grid-template-columns: 1fr auto;
        }
      </style>
      <div class="base">
        <div class="default-slot"><slot></slot></div>
        <div class="sort-row"><slot name="sort"></slot></div>
      </div>
    `, a == null || a.forEach((o) => {
    if (!("beaconSortable" in o.dataset)) return;
    const r = document.createElement("div");
    r.dataset.beaconSortState = String(this.sortable), o.childNodes.forEach(
      (c) => r.appendChild(c)
    ), o.appendChild(r), r.attachShadow({ mode: "open" }).appendChild(
      t.content.cloneNode(!0)
    );
    const b = document.createElement("template");
    b.innerHTML = `
        <${this.getScopedTagName("beacon-icon-button")} slot="sort" variant="tertiary" data-beacon-sort>
          <svg data-metrics-link-text="Sort ascending" class="ascending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z"/>
          </svg>
          <svg data-metrics-link-text="Sort descending" class="descending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
            />
          </svg>
          <svg class="default" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" />
          </svg>
          <span class="sort-text">Sort</span>
        </${this.getScopedTagName("beacon-icon-button")}>
        `;
    const f = b.content.cloneNode(!0);
    r.appendChild(f);
    const s = r.querySelector(
      this.getScopedTagName("beacon-icon-button")
    );
    s == null || s.addEventListener(F.CLICK, () => {
      var c;
      M(this, O, k(this, O) === q.ASCENDING ? q.DESCENDING : q.ASCENDING), R(c = d, x, U).call(c, o, k(this, O)), ae(o, F.SORT);
    });
  }), M(this, H, !0);
}, A(d, x), d.tagName = re.beaconTagName, d);
v([
  B({ reflect: !0 })
], u.prototype, "variant", 2);
v([
  B({ type: Boolean })
], u.prototype, "sortable", 2);
v([
  B({ type: Boolean, attribute: "use-cards" })
], u.prototype, "useCards", 2);
v([
  K()
], u.prototype, "hasMultiLevel", 2);
v([
  B({ attribute: "mobile-full-bleed", type: Boolean })
], u.prototype, "mobileFullBleed", 2);
v([
  B({ reflect: !0 })
], u.prototype, "density", 2);
v([
  B({ attribute: "static-header", type: Boolean, reflect: !0 })
], u.prototype, "staticHeader", 2);
v([
  K()
], u.prototype, "scrollPositionBlock", 2);
v([
  K()
], u.prototype, "scrollPositionInline", 2);
v([
  ne(".table-container")
], u.prototype, "tableContainer", 2);
v([
  ne(".transformed-cards")
], u.prototype, "_transformedCardsContainer", 2);
v([
  V("hasMultiLevel")
], u.prototype, "_setMultiLevelAttribute", 1);
v([
  V("isMediumBreakpoint")
], u.prototype, "_handleBreakpointChanges", 1);
v([
  V("useCards")
], u.prototype, "_handleCardChanges", 1);
v([
  V("sortable")
], u.prototype, "_handleSortChanges", 1);
let _e = u;
export {
  _e as BeaconTable
};
